import { Calendar2, Degree2, Globe } from "@/components/Svg";
import CDatePicker from "@/components/main/form/CDatePicker";
import CInput from "@/components/main/form/CInput";
import CNumberInput from "@/components/main/form/CNumberInput";
import CSelect from "@/components/main/form/CSelect";
import SectorsInput from "@/components/web/main/inputComponents/SectorsInput";
import { Button, CloseButton, Modal } from "@mantine/core";
import {
  IconGenderAgender,
  IconGenderMale,
  IconLocation,
  IconMapPin,
  IconStackPop,
} from "@tabler/icons-react";
import Degrees from "@/resources/degrees.json";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import OrganizationsInput from "@/components/web/main/inputComponents/OrganizationsInput";
import CitizenshipsInput from "../inputComponents/CitizenshipsInput";
import FieldOfStudyInput from "../inputComponents/FieldOfStudyInput";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import Languages from "@/resources/languages.json";
import CountriesInput from "../inputComponents/CountriesInput";

const ExpertsAdvancedSearchModal = ({
  show,
  setShow,
  dictionary,
  onApply,
  values,
}) => {
  const form = useForm({
    initialValues: { location: "", sectors: [] },
  });

  useEffect(() => {
    form.setValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const [hasSearch, setHasSearch] = useState(false);
  const resetSearch = () => {
    form.reset();
    form.resetTouched();
    if (hasSearch) {
      onApply({});
    }
    setHasSearch(false)
  }

  return (
    <Modal
      centered
      overlayProps={{ blur: 5 }}
      lockScroll={true}
      opened={show}
      onClose={() => {
        setShow(false);
      }}
      size={"xl"}
      withCloseButton={false}
      padding={0}
      radius={"lg"}
      styles={{ content: { overflowY: "unset !important" } }}
    >
      <div className="bg-primaryOpacity py-4 px-5 flex items-center">
        <h4 className="my-0 ms-3 text-greyDark text-lg">
          {dictionary.advancedSearch}
        </h4>
        <CloseButton
          size={"md"}
          className="ms-auto"
          onClick={() => {
            setShow(false);
          }}
        />
      </div>
      <div className="p-8 py-6">
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <CitizenshipsInput form={form} dictionary={dictionary} />
          </div>
          <div className="w-full">
            <SectorsInput
              form={form}
              dictionary={dictionary}
              creatable={false}
            />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <FieldOfStudyInput
              form={form}
              dictionary={dictionary}
              clearable={true}
            />
          </div>
          <div className="w-full">
            <CMultiSelect
              data={Languages}
              searchable
              placeholder={dictionary.languages}
              className="mt-3"
              icon={<Globe />}
              limit={5}
              hoverOnSearchChange={true}
              filter={(value, selected, item) => {
                return (
                  item.value.toLowerCase().startsWith(value.toLowerCase()) &&
                  !selected
                );
              }}
              {...form.getInputProps("languages")}
            />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <CMultiSelect
              placeholder={dictionary.genders}
              className="mt-3"
              icon={<IconGenderMale />}
              clearable
              data={[
                {
                  value: "Male",
                  label: dictionary.Male,
                },
                {
                  value: "Female",
                  label: dictionary.Female,
                },
                {
                  value: "Not Specified",
                  label: dictionary["Not Specified"],
                },
              ]}
              {...form.getInputProps("gender")}
            />
          </div>
          <div className="w-full">
            <CountriesInput form={form} placeholder={dictionary.countriesWorkedIn} />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <div className="w-full">
              <CNumberInput
                placeholder={dictionary.minExperience}
                className="mt-3"
                icon={<Calendar2 />}
                min={0}
                {...form.getInputProps("minExperience")}
              />
            </div>
          </div>
          <div className="w-full">
            <CSelect
              placeholder={dictionary.minEducation}
              className="mt-3"
              searchable
              clearable
              icon={<Degree2 />}
              data={Degrees}
              {...form.getInputProps("minEducation")}
            />
          </div>
        </div>
        <div className="flex">
          <div className="ms-auto space-x-3 mt-5">
            <Button
              variant="outline"
              onClick={() => resetSearch()}
            >
              {dictionary.clear}
            </Button>
            <Button
              variant="gradient"
              onClick={() => {
                setHasSearch(true)
                onApply(form.values);
                setShow(false);
              }}
            >
              {dictionary.apply}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExpertsAdvancedSearchModal;
